import React, {useEffect} from "react";
import { Content } from "components/Layout";
import Piepagina from "./FooterHomePublica";
import Cabecera from "./CabeceraHomePublica";
import { withRouter } from "react-router-dom";
import {connect} from "react-redux";
import { ServiciosMenuFetch } from "../../redux/actions/aMenus";
import  { useDispatch }  from 'react-redux';


const HomePublica = ({ children, carritoVisible }) => {
    // hooks
    const dispatch = useDispatch();


    useEffect(() => {
      const initService = async() => await dispatch(ServiciosMenuFetch());
      initService();
    }, [])

    // return view
    return(
      <main className="cr-app">
        <Content fluid>
          <Cabecera carritoVisible={carritoVisible} />
          {children}
          <Piepagina />
        </Content>
      </main>
    );
}


const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => {
  return {
    ServiciosMenuFetch: () => dispatch(ServiciosMenuFetch()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HomePublica)
);
